import { PhasrListWebComponent } from './component/PhasrListWebComponent';
import { PhasrListItemWebComponent } from './component/PhasrListItemWebComponent';

export { PhasrListWebComponent, PhasrListItemWebComponent };
